module.exports = __webpack_public_path__ + "static/media/big_explosion.1349ca1b.png";